import { Link, useLocation } from "react-router-dom";
import { Compass, ShieldOff } from "lucide-react";

const Card = ({ icon: Icon, title, body, testId }) => (
  <div className="flex min-h-[60vh] items-center justify-center px-6" data-testid={testId}>
    <div className="max-w-md text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"><Icon className="h-6 w-6 text-slate-500" /></div>
      <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
      <p className="mt-2 text-sm text-slate-500">{body}</p>
      <Link to="/" className="mt-6 inline-flex rounded-full bg-slate-900 px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-700" data-testid={`${testId}-home`}>Go to Home</Link>
    </div>
  </div>
);

export function NotFound() {
  const { pathname } = useLocation();
  return <Card icon={Compass} title="Page not found" body={`There is no page at ${pathname}. It may have moved, or the link is mistyped.`} testId="page-not-found" />;
}

export function AccessDenied() {
  return <Card icon={ShieldOff} title="Access denied" body="This area is for SUNTRONIX staff only. If you need something here, contact your account manager." testId="access-denied" />;
}
